import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { HelperService } from '../Helper/helper.service';
import { catchError } from 'rxjs/operators';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router'; 

declare var io: any;

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  apiURL: string = environment.apiURL;
  baseUrl: string = environment.baseUrl;
  userDetails = new Subject();
  userProfileUpdate = new Subject();

  public systemSocket:any;

  connectSocket() {
    if (typeof io !== 'undefined') {
      this.systemSocket = io.connect(environment.socketUrl, {
        extraHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
      });
    }
  }
  
  private changeProfileImage = new BehaviorSubject(0);
  currentImage = this.changeProfileImage.asObservable();

  changeCountry = new Subject();

  footerFun = new Subject();
  logOut = new Subject();
  planlist = new Subject();
  itemList = new Subject();
  subscription = new Subject();
  plan = new Subject();

  constructor(
    private http: HttpClient,
    private helperService: HelperService,
    private router: Router
  ) { }

  changeImageFunction(message: number){
    this.changeProfileImage.next(message);
  }

  // Listing pages (vehicles, spareparts, garages, dealers) share a single set of
  // sessionStorage filter keys. Call this on entering a listing page: if the user
  // switched to a different category, the carried-over make/model/location filters
  // are dropped so they aren't replayed into the new category's API call (which the
  // backend would reject, e.g. "Not A Valid Model Id"). Same-category navigation
  // keeps the filters.
  resetListingFiltersOnCategoryChange(pageType: string) {
    if (sessionStorage.getItem('type') !== pageType) {
      ['makeId', 'makeName', 'modelId', 'modelName',
       'stateId', 'stateName', 'cityId', 'cityName']
        .forEach(key => sessionStorage.removeItem(key));
    }
    sessionStorage.setItem('type', pageType);
  }

   //Patch API call

  patchAPICall(requestData: any){
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }
    return this.http.patch<any>(this.apiURL + requestData.url, requestData.data, { headers, params })
      .pipe(
        catchError(this.helperService.handleError('error ', []))
    );
  }



  // Post API Call
  postAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }

    return this.http.post<any>(this.apiURL + requestData.url, requestData.data, { headers })
      .pipe(
        catchError(this.helperService.handleError('error ', []))
    );
  }

  // Post Upload API Call
  postUploadAPICall(requestData: any): Observable<HttpEvent<any>> {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }

    const req = new HttpRequest('POST', `${this.apiURL}${requestData.url}`, requestData.data, {
      headers: headers,
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  // Get API Call
  getAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }

    return this.http.get<any>(this.apiURL + requestData.url, { headers, params })
      .pipe(
        catchError(this.helperService.handleError('error ', []))
    );
  }




  // Put API Call
  putAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }
    return this.http.put<any>(this.apiURL + requestData.url, requestData.data, { headers, params })
      .pipe(
        catchError(this.helperService.handleError('error ', []))
    );
  }

  // Put API Call
  putAPICallUpdate(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }

    return this.http.put<any>(this.apiURL + requestData.url, requestData.data, { headers })
      .pipe(
        catchError(this.helperService.handleError('error ', []))
    );
  }

  // Delete API Call
  deleteAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if(localStorage.getItem('token')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
    }

    return this.http.delete<any>(this.apiURL + requestData.url, { headers })
      .pipe(
        catchError(this.helperService.handleError('error ', []))
    );
  }


     // Fetch  Details
  fetchAboutMe() {
      this.getAPICall({
        url: 'auth/me'
      }).subscribe((result)=>{
        if(result.statusCode == 200) {
          localStorage.setItem('isActive', result.data.isActive);
          if(result.data.artist_details.isActive == true) {
            return;
          }
          else {
            this.router.navigate(['/users/login']);
          }
        }
      },(err)=>{
        this.helperService.showError(err.error.msg)
      })
  }

  checkActiveUser() {
    this.fetchAboutMe();
  }

   setUserProfileUpdate(data:any) {
    this.userProfileUpdate.next(data);
  }

  getUserProfileUpdate() {
    return this.userProfileUpdate.asObservable();
  }


  setUserStatus(data:any) {
    this.userDetails.next(data);
  }
  getUserStatus() {
    return this.userDetails.asObservable();
  }

  setChangeCountry(data:any) {
    this.changeCountry.next(data);
  }
  getChangeCountry() {
    return this.changeCountry.asObservable();
  }

  setFooter(data:any){
    this.footerFun.next(data)
  }

  getFooter() {
    return this.footerFun.asObservable();
  }

  setLogout(data:any) {
    this.logOut.next(data);
  }
  getLogout() {
    return this.logOut.asObservable();
  }

  setPlan(data:any) {
    this.planlist.next(data);
  }
  getPlan() {
    return this.planlist.asObservable();
  }

  
  showPlan(data:any) {
    this.plan.next(data);
  }
  hidePlan() {
    return this.plan.asObservable();
  }

  setItems(data:any) {
    this.itemList.next(data);
  }
  getItems() {
    return this.itemList.asObservable();
  }


  setShowSubscription(data:any) {
    this.subscription.next(data);
  }
  getShowSubscription() {
    return this.subscription.asObservable();
  }

}
